<nav class="navbar navbar-expand-md fixed-top navbar-dark flex-fill">
    <!-- <button class="sidebar-toggler ms-4" type="button">
      <i class="fa fa-navicon"></i>
    </button> -->
    <!-- header -->
    <div class="navbar-header ps-2 pe-2 ms-3 text-center">
      <a class="navbar-brand m-0 w-100" href="#">
        <!-- <i class="fa fa-flash me-1"></i> -->
        <i class="fa fa-bolt fa-1x"></i>
        <span class="ms-2 h4">PDG Light</span>
      </a>
    </div>
    <!-- sidebar toggler -->
    <div class="sidebar-toggler ms-auto me-3">
      <a class="btn nav-link" (click)="toggleSidebar()"><i class="fa fa-bars"></i></a>
    </div>
    <!-- right menu toggler -->
    <div class="nav-toggler-right me-4 d-md-none">
      <button class="" type="button" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
        aria-controls="collapseBasic">
        <!-- <span class="navbar-toggler-icon"></span> -->
        <img src="./assets/img/user.jpg" class="img-fluid" alt="">
      </button>
      <span class="user-profile nav-alert bg-danger"></span>
    </div>
    <!-- left box -->
    <ul class="navbar-nav flex-fill mt-1 align-items-center left-nav">
      <li class="nav-item navicon">
        <a class="btn nav-link" (click)="toggleSidebarPin()"><i class="fa fa-bars"></i></a>
      </li>
    </ul>
  
    <!-- right menu -->
    <div class="collapse navbar-collapse right-nav" id="collapseBasic" [ngbCollapse]="isCollapsed">
      <ul class="navbar-nav ">
        <li class="nav-item">
          <a class="btn nav-link">
            <i class="far fa-bell"></i>
            <span class="link-text">Alerta</span>
            <!-- <span class="badge badge-pill ba dge-danger">3</span> -->
            <span class="nav-alert notifications"></span>
          </a>
        </li>
        <li class="nav-item">
          <a class="btn nav-link" (click)="signOff()">
            <i class="fa-solid fa-arrow-right-from-bracket"></i>
            <span class="link-text">Cerrar sesion</span>
          </a>
        </li>
      </ul>
    </div>
  
  
  
  </nav>